import { Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationUrlsService {
  public readonly postLogoutRedirectBaseUrl = 'http://organicresponse.com';

  private readonly apiUrl: string;
  private readonly baseUrl: string;

  constructor() {
    const { apiUrl } = environment;
    this.apiUrl = apiUrl;
    this.baseUrl = window.location.host;
  }

  get logoutBaseUrl(): string {
    return `${this.apiUrl}/auth/perform_logout`;
  }

  authenticateBaseUrl(apiUrlNeeded = false): string {
    if (apiUrlNeeded) {
      return `${this.apiUrl}/api/v1/user/oauth/auth0?target=${this.apiUrl}`;
    }
    return `${this.apiUrl}/api/v1/user/oauth/auth0?target=http://${this.baseUrl}`;
  }
}
